// src/App.js
import "./common/css/table.css";

import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { fetchPermissions } from "./store/slices/permissionsSlice";
import PublicRoutes from "./routes/PublicRoutes";
import UnauthorizedPage from "./domains/auth/pages/UnauthorizedPage";
import ProtectedRoute from "./routes/ProtectedRoute";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from "@tanstack/react-query";
import NotFound404 from "./NotFound404";
import { CallGETAPI } from "./common/services";
import { DecryptToken } from "./common/helper";
import PrivateRoutes from "./routes/PrivateRoutes";
const queryClient = new QueryClient();

const App = () => {
  const dispatch = useDispatch();
  const user = DecryptToken();
  const authStatus = true; // useSelector(selectAuthStatus);

  useEffect(() => {
    if (authStatus === "authenticated") {
      dispatch(fetchPermissions());
    }
  }, [authStatus, dispatch]);

  const fetchPermissionAPI = async () => {
    const user = await DecryptToken();
    Number(user?.user_type) === 1
      ? sessionStorage.removeItem("per")
      : localStorage.removeItem("Permission");

    const result = await CallGETAPI("auth/priviledge");
    const permission = JSON.stringify(result?.data?.data?.data);
    if (permission) {
      Number(user?.user_type) === 1
        ? sessionStorage.setItem("per", permission)
        : localStorage.setItem("Permission", permission);
    } else {
      console.error("Permission is undefined or null.");
    }
    return result?.data?.data?.data;
  };

  useEffect(() => {
    const token = localStorage.getItem("ross_token");
    if (token && Number(user?.user_type) != 0) fetchPermissionAPI();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          {/* Public Routes */}
          {PublicRoutes.map((item, i) => (
            <Route key={i} exact path={item.path} element={item.component} />
          ))}

          <Route element={<PrivateRoutes />}>
            {ProtectedRoute.map((item, i) => (
              <Route key={i} exact path={item.path} element={item.component} />
            ))}
          </Route>

          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
          <Route path="*" element={<NotFound404 />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
